export default __webpack_public_path__ + "static/1360-d54fb6137f3508b3ec1b4a69332c8340.gif";